import { useDispatch } from 'react-redux'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import { actions } from '../../InventoryState'

export default ({
  open, setOpen, skuToDelete, skusList,
}) => {
  const dispatch = useDispatch()

  const onConfirmModal = () => {
    const updatedSkusList = skusList.filter((sku) => sku.codProduct !== skuToDelete)
    dispatch(actions.setSkusListDelete({ skusList: updatedSkusList }))
    setOpen(false)
  }

  return (
    <ConfirmOrRejectModal
      show={open}
      title='Deletar SKU'
      description={`Você tem certeza que deseja deletar o SKU ${skuToDelete}?`}
      onConfirm={() => onConfirmModal()}
      onReject={() => setOpen(false)}
      onClose={() => setOpen(false)}
    />
  )
}
